import { Notifications } from '../../types/notifications.types';

export const NOTIFICATIONS_INITIAL_VALUE: Notifications = {};
